import React from 'react';
import { Tag } from 'antd';

const colors = {
  "Paid": {
    title: 'Paid',
    color: 'green',
  },
  "Not Paid": {
    title: 'Not Paid',
    color: 'red',
  },
  "Pending Payment": {
    title: 'Pending Payment',
    color: 'yellow',
  }
};

function PrintStatusInvoice({ status }) {
  if (status) {
    return (
        <Tag
          color={(colors[status] && colors[status].color) || 'lime'}
          className="mr-clear"
        >
          {(colors[status] && colors[status].title) || status}
        </Tag>
    );
  }
  return '';
}

export default PrintStatusInvoice;
